import { render } from "./global_search.html?vue&type=template&id=b7369086&external"
import script from "./global_search.js?vue&type=script&lang=js&external"
export * from "./global_search.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__